import { React } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Icon } from '@digsup/components-icon';
import isString from 'lodash.isstring';
import { Text } from '@digsup/components-text';

function titleFontSize(title) {
  if (title && title.length < 25) {
    return 'xs';
  }
  return '2xs';
}

export const Header = ({ iconName, title, icon }) => {
  let iconNameProps = null;
  if (isString(iconName)) {
    iconNameProps = { name: iconName };
  } else if (iconName) {
    iconNameProps = iconName;
  }

  return (
    <>
      {iconNameProps && (
        <div className="u-margin-bottom-small">
          <Icon size="medium" shape="round" {...iconNameProps} />
        </div>
      )}
      {icon && <div className="u-margin-bottom-small">{icon}</div>}
      {title && (
        <Text
          fontFamily="serif"
          fontWeight="semibold"
          size={titleFontSize(title)}
          marginBottom="small">
          {title}
        </Text>
      )}
    </>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  iconName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  icon: PropTypes.node,
};

Header.defaultProps = {};
